// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyDJtEYpdS6IJRvJnqfzx8x1URvQlWWN-IE",
    authDomain: "stanfood-a9582.firebaseapp.com",
    projectId: "stanfood-a9582",
    storageBucket: "stanfood-a9582.appspot.com",
    messagingSenderId: "855449904046",
    appId: "1:855449904046:web:0ccc09732cefaa68b61e3f",
    measurementId: "G-WQWLHQ9HH9"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export default app